import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from './App';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { News } from './pages/News';
import { NewsItem } from './pages/NewsItem';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { DoNotSell } from './pages/DoNotSell';
import { MobileTerms } from './pages/MobileTerms';
import { NotFound } from './pages/NotFound';
import './styles.css';

const appRoutes = [
  { index: true, element: <Home /> },
  { path: 'about', element: <About /> },
  { path: 'news', element: <News /> },
  { path: 'news/:id', element: <NewsItem /> },
  { path: 'contact', element: <Contact /> },
  { path: 'privacy', element: <Privacy /> },
  { path: 'do-not-sell', element: <DoNotSell /> },
  { path: 'mobile-terms', element: <MobileTerms /> },
  { path: '*', element: <NotFound /> },
];

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: appRoutes,
  },
  {
    path: '/legacy',
    element: <App />,
    children: appRoutes,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
